const Emitter = require('events')

class CodevEmitter extends Emitter {
  constructor () {
    super()
  }

  finish (type, ...args) {
    // Refer the process of `Emitter.emit` to rewrite

    // TODO handle error event

    // CORE, call the listeners and wait them to finish
    const listeners = this.listeners(type)
    return Promise.all(listeners.map(l => l(...args)))
  }
}

module.exports = CodevEmitter



//////////////////
// WEBPACK FOOTER
// ./~/await-emitter/src/index.js
// module id = 1046
// module chunks = 0